import React from "react";

import dynamic from "next/dynamic";

import { SMSCodeStepProps } from "./types";

// Disabled SSR to avoid memory leak caused by styled
export const SMSCodeStep = dynamic(() => import("./SMSCodeStepSsr").then((mod) => mod.SMSCodeStepSsr), {
  ssr: false,
}) as React.FunctionComponent<React.PropsWithChildren<SMSCodeStepProps>>;
